module.exports = __webpack_public_path__ + "static/media/help_white.e61d068c.svg";